
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/converter/xml-to-json",
      function () {
        return require("private-next-pages/converter/xml-to-json.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/converter/xml-to-json"])
      });
    }
  